import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import {
    ACCESS_SELECTORS,
    MarketerAccess,
    MarketerProduct,
    MarketerProductsCellItem,
    MarketersPageStates
} from '../../typings/marketers';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';
import { EditableCell } from '../EditableCell/EditableCell';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';
import { SelectDecorator } from '../SelectDecorator/SelectDecorator';

import './MarketerProductAccessCell.css';
import * as keyset from './MarketerProductAccessCell.i18n';

const BLOCK = 'marketer-product-access-cell';
const i18n = i18nFactory(keyset);

export interface MarketerProductAccessCellProps {
    product: MarketerProductsCellItem;
    pageStatus: MarketersPageStates;
    changeMarketerProduct: (product: MarketerProduct) => void;
    changeMarketerAccessCell: (product: MarketerProductsCellItem) => void;
    isGridScrolling: boolean;
}

export class MarketerProductAccessCell extends React.Component<
    MarketerProductAccessCellProps
> {
    public componentDidUpdate() {
        const {
            isGridScrolling,
            product: { isEdited }
        } = this.props;
        if (isEdited && isGridScrolling) {
            this.toggleForm();
        }
    }

    render() {
        const {
            product: { access, selectedAccess, isEdited },
            isGridScrolling
        } = this.props;

        return (
            <>
                <EditableCell isActive={isEdited} onClick={this.toggleForm}>
                    {access}
                </EditableCell>
                <PopupDecorator
                    anchor={this}
                    visible={isEdited && !isGridScrolling}
                    target={'anchor'}
                    directions={['top-center']}
                    hasTail={true}
                    header={i18n('access')}
                    footer={this.renderFooter()}
                    onOutsideClick={this.toggleForm}
                >
                    <SelectDecorator
                        cls={Bem.cls(BLOCK, 'select')}
                        popup={{ hiding: false }}
                        size="s"
                        theme="normal"
                        width="max"
                        type="radio"
                        view="classic"
                        items={ACCESS_SELECTORS}
                        val={selectedAccess}
                        onChange={this.onAccessChange}
                    />
                </PopupDecorator>
            </>
        );
    }

    private renderFooter = () => {
        const {
            pageStatus,
            product: { access, selectedAccess }
        } = this.props;

        return (
            <>
                <ButtonDecorator
                    cls={Bem.cls(BLOCK, 'action')}
                    theme={'action'}
                    size={'s'}
                    text={i18n('save')}
                    onClick={this.onAccessSave}
                    progress={pageStatus === MarketersPageStates.ACTION}
                    disabled={access === selectedAccess}
                />
                <ButtonDecorator
                    theme={'normal'}
                    size={'s'}
                    text={i18n('cancel')}
                    onClick={this.toggleForm}
                    disabled={pageStatus === MarketersPageStates.ACTION}
                />
            </>
        );
    };

    private toggleForm = () => {
        const { changeMarketerAccessCell, product } = this.props;

        changeMarketerAccessCell({
            ...product,
            selectedAccess: product.access,
            isEdited: !product.isEdited
        });
    };

    private onAccessChange = (access: MarketerAccess[]) => {
        const { changeMarketerAccessCell, product } = this.props;

        if (access.length) {
            changeMarketerAccessCell({
                ...product,
                selectedAccess: access[0]
            });
        }
    };

    private onAccessSave = () => {
        const { changeMarketerProduct, product } = this.props;

        if (product.selectedAccess !== product.access) {
            changeMarketerProduct(product);
        }
    };
}
